import React from 'react'

import './WebinarSidebarSeparator.scss'

interface WebinarSidebarSeparatorProps {
  isFullWidth?: boolean
}

const WebinarSidebarSeparator = ({
  isFullWidth = false,
}: WebinarSidebarSeparatorProps) => {
  return (
    <div
      className="webinar-sidebar-separator"
      data-is-full-width={isFullWidth}
    />
  )
}

export default WebinarSidebarSeparator
